<template>
	<div class="menu_warp">
		<div class="tit_warp">
			<span class="fontSiz14">详情</span>
			<div class="pointer fontSiz14 col-333 fontWeight" @click="closeModal()">
				<span class="iconfont icon-shanchu"></span>
			</div>
		</div>

		<div class="rpt_warp">
			<div class="flex">
				<div class="rpt_tit">基本信息</div>
				<div class="editimg">
					<div v-if="vehedit" @click="userLogout">编辑</div>
					<div class="flex fontSize18" v-else>
						<div class="mr-10" @click="userLogout">保存</div>
						<div @click="userLogout">取消</div>
					</div>
				</div>
			</div>
			<div class="rpt_box2">
				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>牵引车车牌号:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="userNickname" placeholder="请输入内容"></el-input>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>所属公司:
						</div>

						<div class="input_box">
							<el-input type="text" v-model="userNickname" placeholder="请输入内容"></el-input>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>车载电话:
						</div>
						<div class="input_box">
							<el-select v-model="conSex" placeholder="请选择">
								<el-option label="男" value="男"> </el-option>
								<el-option label="女" value="女"> </el-option>
							</el-select>
						</div>
					</div>
				</div>

				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>压力表数量:
						</div>
						<div class="input_box">
							<el-input type="number" v-model="conAge" placeholder="请输入内容"></el-input>
						</div>
					</div>

					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>安全阀数量:
						</div>
						<div class="input_box">
							<el-input v-model="conNation" disabled type="text" placeholder="请输入内容"></el-input>
						</div>
					</div>

					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>轴数:
						</div>
						<div class="input_box">
							<el-input v-model="conBirth" disabled type="text" placeholder="请输入内容"></el-input>
						</div>
					</div>
				</div>

				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>车长:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="conCardid" placeholder="请输入内容"></el-input>
						</div>
					</div>

					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>车宽:
						</div>
						<div class="input_box">
							<el-select v-model="orgId" placeholder="请选择" @change="orgIdChange()">
								<el-option v-for="(item, index) in orgList" :key="index" :label="item.orgName"
									:value="item.orgId">
								</el-option>
							</el-select>
						</div>
					</div>

					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>车高:
						</div>
						<div class="input_box">
							<el-input v-model="conMobile" type="number" placeholder="请输入内容"></el-input>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="rpt_warp m-top20">
			<div class="flex">
				<div class="rpt_tit">牵引车辆行驶证-正面</div>
				<div class="editimg" @click="userLogout">
					<img src="@/assets/images/handle/edit-b.png" alt="" />
					<span>编辑</span>
				</div>
			</div>
			<div class="rpt_box2">
				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>号牌号码:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="userNickname" placeholder="请输入内容"></el-input>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>车辆类型:
						</div>

						<div class="input_box">
							<el-input type="text" v-model="userNickname" placeholder="请输入内容"></el-input>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>车辆所有人:
						</div>
						<div class="input_box">
							<el-select v-model="conSex" placeholder="请选择">
								<el-option label="男" value="男"> </el-option>
								<el-option label="女" value="女"> </el-option>
							</el-select>
						</div>
					</div>
				</div>

				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>住址:
						</div>
						<div class="input_box">
							<el-input type="number" v-model="conAge" placeholder="请输入内容"></el-input>
						</div>
					</div>

					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>使用性质:
						</div>
						<div class="input_box">
							<el-input v-model="conNation" disabled type="text" placeholder="请输入内容"></el-input>
						</div>
					</div>

					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>品牌型号:
						</div>
						<div class="input_box">
							<el-input v-model="conBirth" disabled type="text" placeholder="请输入内容"></el-input>
						</div>
					</div>
				</div>

				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>车辆识别号（VIN）:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="conCardid" placeholder="请输入内容"></el-input>
						</div>
					</div>

					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>发动机号码:
						</div>
						<div class="input_box">
							<el-select v-model="orgId" placeholder="请选择" @change="orgIdChange()">
								<el-option v-for="(item, index) in orgList" :key="index" :label="item.orgName"
									:value="item.orgId">
								</el-option>
							</el-select>
						</div>
					</div>

					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>注册日期:
						</div>
						<div class="input_box">
							<el-input v-model="conMobile" type="number" placeholder="请输入内容"></el-input>
						</div>
					</div>
				</div>

				<div class="input_row2">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>发证日期:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="conCardid" placeholder="请输入内容"></el-input>
						</div>
					</div>

					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>发证机关:
						</div>
						<div class="input_box">
							<el-select v-model="orgId" placeholder="请选择" @change="orgIdChange()">
								<el-option v-for="(item, index) in orgList" :key="index" :label="item.orgName"
									:value="item.orgId">
								</el-option>
							</el-select>
						</div>
					</div>

					<div class="input_cell2">
						<div class="rpic_img_warp flex">
							<div class="fontSize14 col-333">
								<span class="col-ff0">*</span>行驶证正面附件:
							</div>
							<el-upload :show-file-list="false" :auto-upload="false" :multiple="false"
								:on-change="uploadRpicUrl" accept=".jpg,.jpeg,.png" v-if="rpicUrl.length < 6">
								<div class="upRpic_icon_item2">
									<img class="upRpic_icon" src="@/assets/images/upload-icon.png" />
									<span class="fontSize14 col-999">上传图片</span>
								</div>
							</el-upload>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="rpt_warp m-top20">
			<div class="flex">
				<div class="rpt_tit">牵引车辆行驶证-背面</div>
				<div class="editimg" @click="userLogout">
					<img src="@/assets/images/handle/edit-b.png" alt="" />
					<span>编辑</span>
				</div>
			</div>
			<div class="rpt_box2">
				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>档案编号:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="userNickname" placeholder="请输入内容"></el-input>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>核定人数:
						</div>

						<div class="input_box">
							<el-input type="text" v-model="userNickname" placeholder="请输入内容"></el-input>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>总质量（KG）:
						</div>
						<div class="input_box">
							<el-select v-model="conSex" placeholder="请选择">
								<el-option label="男" value="男"> </el-option>
								<el-option label="女" value="女"> </el-option>
							</el-select>
						</div>
					</div>
				</div>

				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>整备质量（KG）:
						</div>
						<div class="input_box">
							<el-input type="number" v-model="conAge" placeholder="请输入内容"></el-input>
						</div>
					</div>

					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>核定载质量（KG）:
						</div>
						<div class="input_box">
							<el-input v-model="conNation" disabled type="text" placeholder="请输入内容"></el-input>
						</div>
					</div>

					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>总牵引总质量（KG）:
						</div>
						<div class="input_box">
							<el-input v-model="conBirth" disabled type="text" placeholder="请输入内容"></el-input>
						</div>
					</div>
				</div>

				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>外廓尺寸（MM）:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="conCardid" placeholder="请输入内容"></el-input>
						</div>
					</div>

					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>检验有效期截止时间:
						</div>
						<div class="input_box">
							<el-select v-model="orgId" placeholder="请选择" @change="orgIdChange()">
								<el-option v-for="(item, index) in orgList" :key="index" :label="item.orgName"
									:value="item.orgId">
								</el-option>
							</el-select>
						</div>
					</div>

					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>燃油类型:
						</div>
						<div class="input_box">
							<el-input v-model="conMobile" type="number" placeholder="请输入内容"></el-input>
						</div>
					</div>
				</div>

				<div class="input_row2">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>强制报废时间:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="conCardid" placeholder="请输入内容"></el-input>
						</div>
					</div>

					<div class="input_cell2">
						<div class="rpic_img_warp flex">
							<div class="fontSize14 col-333">
								<span class="col-ff0">*</span>行驶证背面附件:
							</div>
							<el-upload :show-file-list="false" :auto-upload="false" :multiple="false"
								:on-change="uploadRpicUrl" accept=".jpg,.jpeg,.png" v-if="rpicUrl.length < 6">
								<div class="upRpic_icon_item2">
									<img class="upRpic_icon" src="@/assets/images/upload-icon.png" />
									<span class="fontSize14 col-999">上传图片</span>
								</div>
							</el-upload>
						</div>
					</div>

					<div class="input_cell">

					</div>
				</div>
			</div>
		</div>

		<div class="rpt_warp m-top20">
			<div class="flex">
				<div class="rpt_tit">道路运输证</div>
				<div class="editimg" @click="userLogout">
					<img src="@/assets/images/handle/edit-b.png" alt="" />
					<span>编辑</span>
				</div>
			</div>
			<div class="rpt_box2">
				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>运输证号:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="userNickname" placeholder="请输入内容"></el-input>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>业户名称:
						</div>

						<div class="input_box">
							<el-input type="text" v-model="userNickname" placeholder="请输入内容"></el-input>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>地址:
						</div>
						<div class="input_box">
							<el-select v-model="conSex" placeholder="请选择">
								<el-option label="男" value="男"> </el-option>
								<el-option label="女" value="女"> </el-option>
							</el-select>
						</div>
					</div>
				</div>

				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>车牌号码:
						</div>
						<div class="input_box">
							<el-input type="number" v-model="conAge" placeholder="请输入内容"></el-input>
						</div>
					</div>

					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>经营许可证号:
						</div>
						<div class="input_box">
							<el-input v-model="conNation" disabled type="text" placeholder="请输入内容"></el-input>
						</div>
					</div>

					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>车辆类型:
						</div>
						<div class="input_box">
							<el-input v-model="conBirth" disabled type="text" placeholder="请输入内容"></el-input>
						</div>
					</div>
				</div>

				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>吨（座）位:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="conCardid" placeholder="请输入内容"></el-input>
						</div>
					</div>

					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>经营范围:
						</div>
						<div class="input_box">
							<el-select v-model="orgId" placeholder="请选择" @change="orgIdChange()">
								<el-option v-for="(item, index) in orgList" :key="index" :label="item.orgName"
									:value="item.orgId">
								</el-option>
							</el-select>
						</div>
					</div>

					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>车辆尺寸（MM）:
						</div>
						<div class="input_box">
							<el-input v-model="conMobile" type="number" placeholder="请输入内容"></el-input>
						</div>
					</div>
				</div>

				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>发证日期:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="conCardid" placeholder="请输入内容"></el-input>
						</div>
					</div>

					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>有效期至:
						</div>
						<div class="input_box">
							<el-select v-model="orgId" placeholder="请选择" @change="orgIdChange()">
								<el-option v-for="(item, index) in orgList" :key="index" :label="item.orgName"
									:value="item.orgId">
								</el-option>
							</el-select>
						</div>
					</div>

					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>核发机关:
						</div>
						<div class="input_box">
							<el-input v-model="conMobile" type="number" placeholder="请输入内容"></el-input>
						</div>
					</div>
				</div>

				<div class="input_row2">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>审验有效期至:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="conCardid" placeholder="请输入内容"></el-input>
						</div>
					</div>

					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>技术等级评定:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="conCardid" placeholder="请输入内容"></el-input>
						</div>
					</div>

					<div class="input_cell2">
						<div class="rpic_img_warp flex">
							<div class="fontSize14 col-333">
								<span class="col-ff0">*</span>道路运输证附件:
							</div>
							<el-upload :show-file-list="false" :auto-upload="false" :multiple="false"
								:on-change="uploadRpicUrl" accept=".jpg,.jpeg,.png" v-if="rpicUrl.length < 6">
								<div class="upRpic_icon_item2">
									<img class="upRpic_icon" src="@/assets/images/upload-icon.png" />
									<span class="fontSize14 col-999">上传图片</span>
								</div>
							</el-upload>
						</div>
					</div>

				</div>
			</div>
		</div>

		<div class="rpt_warp m-top20">
			<div class="flex">
				<div class="rpt_tit">注册登记摘要</div>
				<div class="editimg" @click="userLogout">
					<img src="@/assets/images/handle/edit-b.png" alt="" />
					<span>编辑</span>
				</div>
			</div>
			<div class="rpt_box2">
				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>资质证号:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="userNickname" placeholder="请输入内容"></el-input>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>业注册登记摘要有效期:
						</div>

						<div class="input_box">
							<el-input type="text" v-model="userNickname" placeholder="请输入内容"></el-input>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>开始日期:
						</div>
						<div class="input_box">
							<el-select v-model="conSex" placeholder="请选择">
								<el-option label="男" value="男"> </el-option>
								<el-option label="女" value="女"> </el-option>
							</el-select>
						</div>
					</div>
				</div>

				<div class="input_row2">
					<div class="input_cell2">
						<div class="rpic_img_warp flex">
							<div class="fontSize14 col-333">
								<span class="col-ff0">*</span>注册登记摘要附件:
							</div>
							<el-upload :show-file-list="false" :auto-upload="false" :multiple="false"
								:on-change="uploadRpicUrl" accept=".jpg,.jpeg,.png" v-if="rpicUrl.length < 6">
								<div class="upRpic_icon_item2">
									<img class="upRpic_icon" src="@/assets/images/upload-icon.png" />
									<span class="fontSize14 col-999">上传图片</span>
								</div>
							</el-upload>
						</div>
					</div>

				</div>
			</div>
		</div>

		<div class="rpt_warp m-top20">
			<div class="flex">
				<div class="rpt_tit">产品合格证</div>
				<div class="editimg" @click="userLogout">
					<img src="@/assets/images/handle/edit-b.png" alt="" />
					<span>编辑</span>
				</div>
			</div>
			<div class="rpt_box2">
				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>资质证号:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="userNickname" placeholder="请输入内容"></el-input>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>产品合格证截止时间:
						</div>

						<div class="input_box">
							<el-input type="text" v-model="userNickname" placeholder="请输入内容"></el-input>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>制造许可证:
						</div>
						<div class="input_box">
							<el-select v-model="conSex" placeholder="请选择">
								<el-option label="男" value="男"> </el-option>
								<el-option label="女" value="女"> </el-option>
							</el-select>
						</div>
					</div>
				</div>

				<div class="input_row2">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>开始日期:
						</div>
						<div class="input_box">
							<el-select v-model="conSex" placeholder="请选择">
								<el-option label="男" value="男"> </el-option>
								<el-option label="女" value="女"> </el-option>
							</el-select>
						</div>
					</div>

					<div class="input_cell2">
						<div class="rpic_img_warp flex">
							<div class="fontSize14 col-333">
								<span class="col-ff0">*</span>产品合格证附件:
							</div>
							<el-upload :show-file-list="false" :auto-upload="false" :multiple="false"
								:on-change="uploadRpicUrl" accept=".jpg,.jpeg,.png" v-if="rpicUrl.length < 6">
								<div class="upRpic_icon_item2">
									<img class="upRpic_icon" src="@/assets/images/upload-icon.png" />
									<span class="fontSize14 col-999">上传图片</span>
								</div>
							</el-upload>
						</div>
					</div>

					<div class="input_cell">
					</div>

				</div>
			</div>
		</div>

		<div class="rpt_warp m-top20">
			<div class="flex">
				<div class="rpt_tit">保险信息</div>
				<div class="editimg" @click="userLogout">
					<img src="@/assets/images/handle/edit-b.png" alt="" />
					<span>编辑</span>
				</div>
			</div>
			<div class="rpt_box3">
				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>保险公司:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="userNickname" placeholder="请输入内容"></el-input>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>联系人:
						</div>

						<div class="input_box">
							<el-input type="text" v-model="userNickname" placeholder="请输入内容"></el-input>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>联系电话:
						</div>
						<div class="input_box">
							<el-select v-model="conSex" placeholder="请选择">
								<el-option label="男" value="男"> </el-option>
								<el-option label="女" value="女"> </el-option>
							</el-select>
						</div>
					</div>
				</div>

				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>强险开始时间:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="userNickname" placeholder="请输入内容"></el-input>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>强险到期时间:
						</div>

						<div class="input_box">
							<el-input type="text" v-model="userNickname" placeholder="请输入内容"></el-input>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>商业险开始时间:
						</div>
						<div class="input_box">
							<el-select v-model="conSex" placeholder="请选择">
								<el-option label="男" value="男"> </el-option>
								<el-option label="女" value="女"> </el-option>
							</el-select>
						</div>
					</div>
				</div>

				<div class="input_row2">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>商业险到期时间:
						</div>
						<div class="input_box">
							<el-select v-model="conSex" placeholder="请选择">
								<el-option label="男" value="男"> </el-option>
								<el-option label="女" value="女"> </el-option>
							</el-select>
						</div>
					</div>

					<div class="input_cell2">
						<div class="rpic_img_warp flex">
							<div class="fontSize14 col-333">
								<span class="col-ff0">*</span>强险附件:
							</div>
							<el-upload :show-file-list="false" :auto-upload="false" :multiple="false"
								:on-change="uploadRpicUrl" accept=".jpg,.jpeg,.png" v-if="rpicUrl.length < 6">
								<div class="upRpic_icon_item2">
									<img class="upRpic_icon" src="@/assets/images/upload-icon.png" />
									<span class="fontSize14 col-999">上传图片</span>
								</div>
							</el-upload>
						</div>
					</div>

					<div class="input_cell2">
						<div class="rpic_img_warp flex">
							<div class="fontSize14 col-333">
								<span class="col-ff0">*</span>商业险附件:
							</div>
							<el-upload :show-file-list="false" :auto-upload="false" :multiple="false"
								:on-change="uploadRpicUrl" accept=".jpg,.jpeg,.png" v-if="rpicUrl.length < 6">
								<div class="upRpic_icon_item2">
									<img class="upRpic_icon" src="@/assets/images/upload-icon.png" />
									<span class="fontSize14 col-999">上传图片</span>
								</div>
							</el-upload>
						</div>
					</div>

				</div>
			</div>
		</div>
	</div>

	<el-dialog title="关联招聘" v-model="isLink" width="50%" center>
		<div class="dialog-container">
			<div class="input-box flex flex-y-center" style="width: 300px">
				<el-input v-model="linkSearch" type="text" placeholder="请输入内容"></el-input>
				<div class="serach_btn" @click="getLinKData()">查询</div>
			</div>

			<div class="link-table m-top10" style="height: 300px; margin-top: 10px">
				<el-table stripe border style="width: 100%" height="300" v-bind:header-cell-style="{
            textAlign: 'center',
            color: '#333333',
            background: '#F5F5F5',
          }" v-bind:cell-style="{ textAlign: 'center' }" empty-text="暂无数据" :data="tableData" ref="radioTable"
					@row-click="rowClick" @selection-change="selectionChange">
					<el-table-column type="selection"> </el-table-column>
					<el-table-column prop="applyPic" label="技师头像">
						<template #default="scope">
							<img :src="scope.row.applyPic" style="width: 50px; height: 50px; border-radius: 10px" />
						</template>
					</el-table-column>
					<el-table-column prop="applyName" label="技师名称"> </el-table-column>

					<el-table-column prop="applyPhone" label="联系电话" show-overflow-tooltip>
					</el-table-column>

					<el-table-column prop="address" label="地址" show-overflow-tooltip>
					</el-table-column>

					<el-table-column prop="applyTime" label="创建时间" show-overflow-tooltip>
					</el-table-column>
				</el-table>
				<el-pagination style="margin-top: 15px" background layout="sizes, prev, pager, next, total, jumper"
					v-bind:page-sizes="[10, 20, 50, 100]" :total="totalCount" v-model:current-page="currentPage"
					v-on:size-change="getLinKData()" v-on:current-change="getLinKData()"
					v-model:page-size="pageSize"></el-pagination>
			</div>
		</div>
		<template #footer>
			<span class="dialog-footer">
				<span class="btn btn-outline-default mr-50" v-on:click="closeModal()">取消</span>
				<span class="btn bg-default" v-on:click="addModal()">确定</span>
			</span>
		</template>
	</el-dialog>

	<el-dialog title="提示" v-model="isShowTips" width="30%" center>
		<div class="dialog-container">
			<div class="text-center fontWeight col-agree fontSize16 col-red mar-bot-20">
				添加成功
			</div>
			<div class="fontSize14 text-center">
				<span class="fontWeight col-ff0">{{ defaultPsw }}</span>
				<span class="mar-left-20 fuzi cursor" @click="myCopy(defaultPsw)">复制</span>
			</div>
		</div>
		<template #footer>
			<span class="dialog-footer">
				<span class="btn bg-default" v-on:click="closeTipsModal()">确定</span>
			</span>
		</template>
	</el-dialog>
</template>

<script>
	import {
		parseTime,
		formatDatetime,
		imgFileToBase64,
		isIdNo,
		isPhone,
		isChinese,
	} from "@/libs/tools";
	import {
		getCurrentInstance
	} from "vue";
	export default {
		name: "DetailtractionVehicle",
		props: {
			sendData: {
				type: Object,
			},
		},
		emits: ["closeModal", "getData"],
		data() {
			return {
				bcProvinceList: [], //银行省
				bcCityList: [], //银行市
				provinceList: [], //省
				cityList: [], //市
				areaList: [], //区县
				orgList: [],
				vehedit: false,
				conCardPeople: "", //身份证正面
				conCardEmblem: "", //身份证背面
				userHeadImg: "", //证件照
				conName: "", //姓名
				conSex: "", //性别
				conAge: "", //年龄
				conNation: "", //民族
				conBirth: "", //出生日期
				conCardid: "", //身份证号
				orgId: "", //子平台id
				orgName: "", //子平台名称
				conMobile: "", //联系电话
				conProvince: "", //省
				conCity: "", //市
				conArea: "", //区县
				conCardAdr: "", //地址
				rptYears: "", //从业时长
				rptConMer: '', //签约商户
				rptIntroduction: "", //技师简介
				conEmail: "", //联系邮箱
				conSchool: "", //毕业院校
				conEducation: "", //最高学历
				conProfession: "", //从事职业
				conMarriage: "", //婚姻状况
				rpicUrl: [], //生活照片
				cretUrl: "", //技能证书(模糊版)
				lookUrl: '', //技能证书(清晰版)
				lookLicenseUrl: '', //营业执照(清晰版)
				licenseUrl: "", //营业执照(模糊版)
				bcNo: "", //银行卡号
				bcName: "", //户名
				bcBank: "", //开户行
				bcBankBranch: "", //开户支行
				bcMobile: "", //预留手机号
				bcPicFront: "", //银行卡正面
				bcPicBack: "", //银行卡背面
				bcProvince: "", //银行卡所属省
				bcCity: "", //银行卡所属市
				files: null,
				isLink: false, //关联招聘
				radio: false,
				selectData: null,
				rptUserId: null, //
				tableData: [],
				totalCount: 0,
				currentPage: 1,
				searchWord: "",
				pageSize: 5,
				bcFlag: "01",
				isZpt: null, //是否是子平台
				rptHongStartTime: "",
				disabledDate: (time) => {
					// 禁用日期
					let nowData = new Date();
					nowData = new Date(nowData.setDate(nowData.getDate() - 1));
					return time < nowData;
				},
				rptHongEndTime: "",
				hDay: null, //红利期区间
				disabledDate1: (time) => {
					// 禁用日期
					let nowData = new Date();
					nowData = new Date(nowData.setDate(nowData.getDate() - 1));
					return time < nowData;
				},
				userNickname: "",
				coverPhoto: "", //详情封面照
				isShowTips: false,
				defaultPsw: "",
				rptParlour: '', //店铺
				shopList: [],
				linkSearch: '',
			};
		},
		watch: {},
		setup(props, context) {
			const {
				proxy
			} = getCurrentInstance();

			const closeModal = () => {
				context.emit("closeModal");
			};

			function myCopy(val) {
				console.log(val);
				// 复制功能
				navigator.clipboard.writeText(val).then(
					function() {
						proxy.$message.success("复制成功");
						/* clipboard successfully set */
					},
					function() {
						proxy.$message.success("复制失败，请手动复制");
						/* clipboard write failed */
					}
				);
			}
			return {
				myCopy,
				closeModal,
			};
		},
		methods: {
			getShop() {
				this.$http
					.post("/admin/bdzl/org/listParlour", {
						searchWord: '',
						page: 1,
						limit: 10000,
						orgProvince: '',
						orgCity: '',
						orgId: this.orgId,
						orgStatus: 0
					})
					.then((res) => {
						if (res.code == 0 || res.respCode == "0000") {

							this.shopList = res.list;

						}
					});
			},
			shopOrgChange() {
				console.log(this.rptParlour)
				this.orgId = ''
				this.shopList.forEach(item => {
					if (this.rptParlour == item.orgId) {
						console.log(item)
						this.orgId = item.orgPid
					}
				})
			},
			//关联招聘
			linkTap() {
				this.isLink = true;
				console.log(this.selectData);
				this.getLinKData();
			},
			//关联招聘
			getLinKData() {
				console.log(this.selectData);
				this.$http
					.get("/biz/bdzl/rptApply/list", {
						page: this.currentPage,
						limit: this.pageSize,
						searchWord: this.linkSearch,
					})
					.then((res) => {
						console.log(res);
						if (res.code == 0) {
							this.tableData = res.rows;
							this.totalCount = res.total;
							if (this.selectData) {
								this.tableData.forEach((item) => {
									if (item.applyUserId == this.selectData.applyUserId) {
										console.log(item);
										this.$refs.radioTable.toggleRowSelection(item, true);
									}
								});
							}
						}
					});
			},
			// 表格的选中 可以获得当前选中的数据
			selectionChange(val) {
				if (val.length > 1) {
					this.$refs.radioTable.clearSelection();
					this.$refs.radioTable.toggleRowSelection(val.pop());
				} else {
					this.selectData = val.pop();
				}
			},
			// 表格某一行的单击事件
			rowClick(row, column) {
				this.$refs.radioTable.toggleRowSelection(row);
			},
			addModal() {
				if (!this.selectData) {
					this.$message.error("请选择技师");
					return;
				}
				this.conName = this.selectData.applyName;
				this.rptUserId = this.selectData.applyUserId;
				this.conSex = this.selectData.applySex;
				this.conMobile = this.selectData.applyPhone;
				this.userHeadImg = this.selectData.applyPic;
				this.conProvince = this.selectData.applyProvince;
				this.getCityList(this.conProvince);
				this.conCity = this.selectData.applyCity;
				this.getAreaList(this.conCity);
				this.isLink = false;
			},
			getOrg(orgId) {
				var that = this;
				this.$http
					.get("/admin/bdzl/org/listPlatform", {
						// searchWord: searchWord,
						orgId: orgId,
						page: 1,
						limit: 10000,
					})
					.then((res) => {
						if (res.code == 0 || res.respCode == "0000") {
							console.log(res);
							this.orgList = res.rows;
						} else {
							that.$message.info(res.msg || res.respMsg);
						}
					});
			},
			orgIdChange() {
				this.rptParlour = ''
				this.getShop()
			},
			getProvinceList() {
				this.$http
					.get("/admin/bdzl/province/list", {
						page: 1,
						limit: 10000
					})
					.then((res) => {
						console.log(res);
						if (res.code == 0) {
							this.provinceList = res.rows;
							this.bcProvinceList = res.rows;
						}
					});
			},
			getConProvince(ev) {
				console.log(ev);
				this.cityList = [];
				this.conCity = "";
				this.areaList = [];
				this.conArea = "";
				this.getCityList(ev);
			},
			getBcProvince(ev) {
				console.log(ev);
				this.bcCityList = [];
				this.bcCity = "";

				this.getBcCityList(ev);
			},
			getCityList(code) {
				this.$http
					.get("/admin/bdzl/city/list", {
						provinceCode: code,
						page: 1,
						limit: 10000,
					})
					.then((res) => {
						console.log(res);
						if (res.code == 0) {
							this.bcCityList = res.rows;
						}
					});
			},
			getBcCityList(code) {
				this.$http
					.get("/admin/bdzl/city/list", {
						provinceCode: code,
						page: 1,
						limit: 10000,
					})
					.then((res) => {
						console.log(res);
						if (res.code == 0) {
							this.bcCityList = res.rows;
						}
					});
			},
			getCityList(code) {
				this.$http
					.get("/admin/bdzl/city/list", {
						provinceCode: code,
						page: 1,
						limit: 10000,
					})
					.then((res) => {
						console.log(res);
						if (res.code == 0) {
							this.cityList = res.rows;
						}
					});
			},
			getConCity(ev) {
				this.areaList = [];
				this.conArea = "";
				this.getAreaList(ev);
			},
			getAreaList(code) {
				this.$http
					.get("/admin/bdzl/area/list", {
						cityCode: code,
						page: 1,
						limit: 10000,
					})
					.then((res) => {
						console.log(res);
						if (res.code == 0) {
							this.areaList = res.rows;
						}
					});
			},
			//身份证正面
			uploadConCardPeople(file) {
				const isLt2M = file.raw.size / 1024 / 1024 < 2;

				if (isLt2M == false) {
					this.$message.error("请上传小于2M的图片");
					return;
				}
				imgFileToBase64(file, (imageUrl) => {
					if (this.conCardPeople.indexOf("https://") !== -1) {
						this.removeImgUrl(this.conCardPeople);
					}
					this.idCardOCR(imageUrl);
				});
			},
			//身份证orc
			idCardOCR(imageUrl) {
				this.$http
					.post("/api/ocr/idCardOCR", {
						url: imageUrl,
						isSave: true,
						type: "front",
					})
					.then((res) => {
						console.log(res);
						if (res.respCode == "0000" && res.userInfo) {
							this.conCardPeople = res.userInfo.conCardPeople;
							this.conName = res.userInfo.conName;
							this.conSex = res.userInfo.conSex;
							this.conAge = this.getAge(res.userInfo.conBirth);
							this.conCardid = res.userInfo.conCardid;
							this.conCardAdr = res.userInfo.conCardAdr;
							this.conNation = res.userInfo.conNation;
							this.conBirth = res.userInfo.conBirth;
						} else {
							this.$message.error("请上传正确的身份证");
						}
					});
			},
			getAge(birthYearMonthDay) {
				//birthYearMonthDay必须为"1995/6/15"这种字符串格式，不可为"2020-6-15"，这种格式在Safari中会报错
				const birthDate = new Date(birthYearMonthDay);
				const momentDate = new Date();
				momentDate.setHours(0, 0, 0, 0); //因为new Date()出来的时间是当前的时分秒。我们需要把时分秒重置为0。使后面时间比较更精确
				const thisYearBirthDate = new Date(
					momentDate.getFullYear(),
					birthDate.getMonth(),
					birthDate.getDate()
				);
				const aDate = thisYearBirthDate - birthDate;
				const bDate = momentDate - birthDate;
				let tempAge = momentDate.getFullYear() - birthDate.getFullYear();
				let age = null;
				if (bDate < aDate) {
					tempAge = tempAge - 1;
					age = tempAge < 0 ? 0 : tempAge;
				} else {
					age = tempAge;
				}
				return age;
			},

			//身份证反面
			uploadConCardEmblem(file) {
				const isLt2M = file.raw.size / 1024 / 1024 < 2;

				if (isLt2M == false) {
					this.$message.error("请上传小于2M的图片");
					return;
				}
				imgFileToBase64(file, (imageUrl) => {
					if (this.conCardEmblem.indexOf("https://") !== -1) {
						this.removeImgUrl(this.conCardEmblem);
					}
					this.upLoadBase64uploadToOSS(imageUrl, "conCardEmblem");
				});
			},
			//形象照
			uploadUserHeadImg(file) {
				const isLt2M = file.raw.size / 1024 / 1024 < 2;

				if (isLt2M == false) {
					this.$message.error("请上传小于2M的图片");
					return;
				}
				imgFileToBase64(file, (imageUrl) => {
					if (this.userHeadImg.indexOf("https://") !== -1) {
						this.removeImgUrl(this.userHeadImg);
					}
					this.upLoadBase64uploadToOSS(imageUrl, "userHeadImg");
				});
			},
			//详情封面照
			uploadCoverPhoto(file) {
				const isLt2M = file.raw.size / 1024 / 1024 < 2;

				if (isLt2M == false) {
					this.$message.error("请上传小于2M的图片");
					return;
				}
				imgFileToBase64(file, (imageUrl) => {
					// if (this.coverPhoto.indexOf("https://") !== -1) {
					//   this.removeImgUrl(this.coverPhoto);
					// }
					this.upLoadBase64uploadToOSS(imageUrl, "coverPhoto");
				});
			},
			//生活照

			uploadRpicUrl(file) {
				const isLt2M = file.raw.size / 1024 / 1024 < 2;
				if (isLt2M == false) {
					this.$message.error("请上传小于2M的图片");
					return;
				}
				imgFileToBase64(file, (imageUrl) => {
					if (this.rpicUrl.length >= 5) {
						this.$message.error("最多上传5张");
						return false;
					}
					this.$http
						.post("/api/ossUpload/base64Json", {
							name: imageUrl,
							value: "123",
						})
						.then((res) => {
							this.rpicUrl.push(res);
						});
				});
			},
			//删除图片
			delImg(index) {
				let url = this.rpicUrl[index];
				if (url.indexOf("https://") !== -1) {
					this.removeImgUrl(url);
				}
				this.rpicUrl.splice(index, 1);
			},
			//技能证书
			uploadCretUrl(file) {
				const isLt2M = file.raw.size / 1024 / 1024 < 2;

				if (isLt2M == false) {
					this.$message.error("请上传小于2M的图片");
					return;
				}
				imgFileToBase64(file, (imageUrl) => {
					if (this.cretUrl.indexOf("https://") !== -1) {
						this.removeImgUrl(this.cretUrl);
					}
					this.upLoadBase64uploadToOSS(imageUrl, "cretUrl");
				});
			},
			uploadLookUrl(file) {
				const isLt2M = file.raw.size / 1024 / 1024 < 2;

				if (isLt2M == false) {
					this.$message.error("请上传小于2M的图片");
					return;
				}
				imgFileToBase64(file, (imageUrl) => {
					if (this.lookUrl.indexOf("https://") !== -1) {
						this.removeImgUrl(this.lookUrl);
					}
					this.upLoadBase64uploadToOSS(imageUrl, "lookUrl");
				});
			},
			//营业执照
			uploadLicenseUrl(file) {
				const isLt2M = file.raw.size / 1024 / 1024 < 2;

				if (isLt2M == false) {
					this.$message.error("请上传小于2M的图片");
					return;
				}
				imgFileToBase64(file, (imageUrl) => {
					if (this.licenseUrl.indexOf("https://") !== -1) {
						this.removeImgUrl(this.licenseUrl);
					}
					this.upLoadBase64uploadToOSS(imageUrl, "licenseUrl");
				});
			},
			//营业执照
			uploadLookLicenseUrl(file) {
				const isLt2M = file.raw.size / 1024 / 1024 < 2;

				if (isLt2M == false) {
					this.$message.error("请上传小于2M的图片");
					return;
				}
				imgFileToBase64(file, (imageUrl) => {
					if (this.lookLicenseUrl.indexOf("https://") !== -1) {
						this.removeImgUrl(this.licenseUrl);
					}
					this.upLoadBase64uploadToOSS(imageUrl, "lookLicenseUrl");
				});
			},
			//银行卡正面
			uploadBcPicFront(file) {
				const isLt2M = file.raw.size / 1024 / 1024 < 2;

				if (isLt2M == false) {
					this.$message.error("请上传小于2M的图片");
					return;
				}
				imgFileToBase64(file, (imageUrl) => {
					console.log(this.bcPicFront);
					if (this.bcPicFront.indexOf("https://") !== -1) {
						this.removeImgUrl(this.bcPicFront);
					}
					this.ocrBank(imageUrl);
				});
			},
			//银行卡ocr
			ocrBank(imageUrl) {
				this.$http
					.post("/api/ocr/bankCardOCR", {
						url: imageUrl,
						isSave: true
					})
					.then((res) => {
						console.log(res);
						if (res.respCode == "0000" && res.bcInfo) {
							this.bcNo = res.bcInfo.bcNo;
							var reg = /[\u4e00-\u9fa5]/g;
							var names = res.bcInfo.bcBank.match(reg);
							this.bcBank = names.join("");

							this.bcPicFront = res.bcInfo.bcUrl;
						} else {
							this.$message.error("识别失败");
						}
					});
			},

			//银行卡背面
			uploadBcPicBack(file) {
				const isLt2M = file.raw.size / 1024 / 1024 < 2;

				if (isLt2M == false) {
					this.$message.error("请上传小于2M的图片");
					return;
				}
				imgFileToBase64(file, (imageUrl) => {
					if (this.bcPicBack.indexOf("https://") !== -1) {
						this.removeImgUrl(this.bcPicBack);
					}
					this.upLoadBase64uploadToOSS(imageUrl, "bcPicBack");
				});
			},
			//上传图片
			upLoadBase64uploadToOSS(imageUrl, type) {
				this.$http
					.post("/api/ossUpload/base64Json", {
						name: imageUrl,
						value: "123",
					})
					.then((res) => {
						// if(res.)
						this[type] = res;
					});
			},
			//删除图片
			removeImgUrl(imageUrl) {
				this.$http
					.get("/biz/bdzl/rptInfo/removeUrl", {
						url: imageUrl
					})
					.then((res) => {});
			},
			//保存
			save() {
				if (this.conCardPeople == "") {
					this.$message.error("请上传身份证正面");
					return;
				}
				if (this.conCardEmblem == "") {
					this.$message.error("请上传身份证背面");
					return;
				}
				if (this.userHeadImg == "") {
					this.$message.error("请上传形象照");
					return;
				}
				if (this.coverPhoto == "") {
					this.$message.error("请上传详情封面照");
					return;
				}
				if (this.conName == "") {
					this.$message.error("请填写姓名");
					return;
				}
				if (this.userNickname == "") {
					this.$message.error("请填写昵称");
					return;
				}
				if (this.conSex == "") {
					this.$message.error("请选择性别");
					return;
				}
				if (this.conAge == "") {
					this.$message.error("请填写年龄");
					return;
				}
				if (this.conCardid == "") {
					this.$message.error("请填写身份证号");
					return;
				}
				if (isIdNo(this.conCardid) == false) {
					this.$message.error("请填写正确的身份证号");
					return;
				}
				if (this.orgId == "") {
					this.$message.error("请选择子平台");
					return;
				}
				if (this.conMobile == "") {
					this.$message.error("请填写联系电话");
					return;
				}
				if (isPhone(this.conMobile) == false) {
					this.$message.error("请填写正确联系电话");
					return;
				}
				if (this.conProvince == "") {
					this.$message.error("请选择省");
					return;
				}
				if (this.conCity == "") {
					this.$message.error("请选择市");
					return;
				}
				if (this.conArea == "") {
					this.$message.error("请选择区县");
					return;
				}
				if (this.conCardAdr == "") {
					this.$message.error("请填写地址");
					return;
				}
				if (this.conArea == "") {
					this.$message.error("请选择区县");
					return;
				}
				if (this.conCardAdr == "") {
					this.$message.error("请填写地址");
					return;
				}
				if (this.rptYears == "") {
					this.$message.error("请填写从业时长");
					return;
				}
				if (this.rptYears <= 0) {
					this.$message.error("请填写正确的从业时长");
					return;
				}
				if (this.rptConMer == '') {
					this.$message.error("请填写签约商家");
					return;
				}
				if (this.rptIntroduction == "") {
					this.$message.error("请填写技师简介");
					return;
				}
				if (this.rpicUrl.length <= 0) {
					this.$message.error("请上传生活照片");
					return;
				}
				if (this.cretUrl == "") {
					this.$message.error("请上传技能证书(模糊版)");
					return;
				}
				if (this.lookUrl == "") {
					this.$message.error("请上传技能证书(清晰版)");
					return;
				}
				if (this.licenseUrl == "") {
					this.$message.error("请上传营业执照(模糊版)");
					return;
				}
				if (this.lookLicenseUrl == "") {
					this.$message.error("请上传营业执照(清晰版)");
					return;
				}
				if (this.rptIntroduction == "") {
					this.$message.error("请填写技师简介");
					return;
				}

				if (this.bcNo == "") {
					this.$message.error("请填写银行卡号");
					return;
				}
				if (this.bcName == "") {
					this.$message.error("请填写户名");
					return;
				}
				if (this.bcBank == "") {
					this.$message.error("请填写开户行");
					return;
				}
				if (this.bcBankBranch == "") {
					this.$message.error("请填写开户支行");
					return;
				}
				if (this.bcMobile == "") {
					this.$message.error("请填写预留手机号");
					return;
				}
				if (isPhone(this.bcMobile) == false) {
					this.$message.error("请填写正确的预留手机号");
					return;
				}
				if (this.bcProvince == "") {
					this.$message.error("请选择银行卡省");
					return;
				}
				if (this.bcCity == "") {
					this.$message.error("请选择银行卡市");
					return;
				}
				if (this.bcPicFront == "") {
					this.$message.error("请上传银行卡正面");
					return;
				}
				if (this.bcPicBack == "") {
					this.$message.error("请上传银行卡背面");
					return;
				}

				let sendData = {
					conCardPeople: this.conCardPeople,
					conCardEmblem: this.conCardEmblem,
					userHeadImg: this.userHeadImg,
					conName: this.conName,
					conSex: this.conSex,
					conAge: this.conAge,
					conCardid: this.conCardid,
					orgId: this.orgId,
					conMobile: this.conMobile,
					conProvince: this.conProvince,
					conCity: this.conCity,
					conArea: this.conArea,
					conCardAdr: this.conCardAdr,
					rptYears: this.rptYears,
					rptIntroduction: this.rptIntroduction,
					conEmail: this.conEmail,
					conSchool: this.conSchool,
					conEducation: this.conEducation,
					conProfession: this.conProfession,
					rpicUrl: this.rpicUrl,
					cretUrl: this.cretUrl,
					lookUrl: this.lookUrl,
					licenseUrl: this.licenseUrl,
					lookLicenseUrl: this.lookLicenseUrl,
					bcNo: this.bcNo,
					bcName: this.bcName,
					bcBank: this.bcBank,
					bcBankBranch: this.bcBankBranch,
					bcMobile: this.bcMobile,
					bcPicFront: this.bcPicFront,
					bcPicBack: this.bcPicBack,
					conNation: this.conNation, //民族
					conBirth: this.conBirth, //出生日期
					conMarriage: this.conMarriage, //婚姻状况
					bcProvince: this.bcProvince,
					bcCity: this.bcCity,
					userId: this.rptUserId,
					bcFlag: this.bcFlag,
					rptHongStartTime: this.rptHongStartTime + " 00:00:00",
					rptHongEndTime: this.rptHongEndTime + " 23:59:59",
					userNickname: this.userNickname,
					coverPhoto: this.coverPhoto,
					rptConMer: this.rptConMer,
					rptParlour: this.rptParlour
				};
				this.$http.post("/biz/bdzl/rptInfo/addRpt", sendData).then((res) => {
					if (res.respCode == "0000") {
						this.$message.success(res.respMsg);
						this.isShowTips = true;
						this.defaultPsw = res.data;
					} else {
						this.$message.error(res.respMsg);
					}
				});
			},
			closeTipsModal() {
				this.isShowTips = false;
				setTimeout(() => {
					this.$bus.emit("changRemoveTabar", "AddConvalescePeople");
					this.$bus.emit("convalesceList", "");
				}, 1000);
			},
			//取消
			cancel() {
				this.$bus.emit("changRemoveTabar", "AddConvalescePeople");
			},
			//获取红利期
			getHDay() {
				this.$http
					.postFormData("/admin/bdzl/config/getByorderReturnPer", {
						configNo: "JS_PT_INTERIM_DAY",
					})
					.then((res) => {
						let days = Number(res.configVal);
						this.hDay = days;
						var dateTime = new Date();
						dateTime = dateTime.setDate(dateTime.getDate() + days);
						dateTime = new Date(dateTime);
						console.log(dateTime);
						let y = dateTime.getFullYear();
						let m = dateTime.getMonth() + 1;
						if (m < 10) {
							m = "0" + m;
						}
						let d = dateTime.getDate();
						if (d < 10) {
							d = "0" + d;
						}
						this.rptHongEndTime = y + "-" + m + "-" + d;
					});
			},
			//获取开始时间
			getStartTime(ev) {
				var dateTime = new Date(ev);
				dateTime = dateTime.setDate(dateTime.getDate() + this.hDay);
				dateTime = new Date(dateTime);
				console.log(dateTime);
				let y = dateTime.getFullYear();
				let m = dateTime.getMonth() + 1;
				if (m < 10) {
					m = "0" + m;
				}
				let d = dateTime.getDate();
				if (d < 10) {
					d = "0" + d;
				}
				this.rptHongStartTime = parseTime(ev, "{y}-{m}-{d}");
				console.log(this.rptHongStartTime);
				this.rptHongEndTime = y + "-" + m + "-" + d;
			},
			getEndTime(ev) {
				this.rptHongEndTime = parseTime(ev, "{y}-{m}-{d}");
				console.log(this.rptHongEndTime);
			},
		},
		created() {},
		mounted() {
			// let userInfo = this.$storage.get("nqdjglUserInfo");
			// if (userInfo.orgId == "TOP") {
			// 	this.getOrg();
			// }
			// if (userInfo.orgId != "TOP") {
			// 	this.getOrg(userInfo.orgId);
			// 	this.orgId = userInfo.orgId;
			// }
			// this.getProvinceList();
			var date = new Date();
			var y = date.getFullYear();
			var month = date.getMonth() + 1;
			if (month < 10) {
				month = "0" + month;
			}
			var day = date.getDate();
			if (day < 10) {
				day = "0" + day;
			}
			this.rptHongStartTime = y + "-" + month + "-" + day;
			this.getHDay();
			this.getShop()
			console.log(day);
		},
	};
</script>

<style scoped>
	#AddConvalescePeople {
		/* background: #f6fffb; */
		overflow: auto;
		padding-top: 20px;
	}

	:deep(.el-table__header .el-table-column--selection .cell .el-checkbox) {
		display: none;
	}

	:deep(.el-table-column--selection .cell) {
		text-align: center;
	}

	:deep(.el-checkbox__input .el-checkbox__inner) {
		border-radius: 50%;
	}

	.el-date-editor.el-input,
	.el-date-editor.el-input__inner {
		width: 100%;
	}

	.el-input--prefix .el-input__inner {
		padding-left: 30px !important;
	}

	.link-box {
		margin-right: 10px;
		font-size: 14px;
		color: #5cc95e;
		cursor: pointer;
		width: 120px;
		text-align: right;
	}

	.box-right-row {
		display: flex;
		align-items: center;
	}

	.img-box {
		width: 460px;
		height: 280px;
		border: 1px solid #eeeeee;
		border-radius: 4px;
		margin-left: 20px;
		display: flex;
		flex-wrap: wrap;
		padding-top: 20px;
	}

	.image-box-item {
		width: 120px;
		height: 120px;
		margin-left: 20px;
		margin-right: 10px;
		margin-bottom: 20px;
		position: relative;
	}

	.image-box-item-upload {
		width: 120px;
		height: 120px;
		border: 1px solid #eeeeee;
		border-radius: 4px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.image-box-item-upload .upload-icon {
		width: 30px;
		height: 30px;
	}

	.bank-img-box {
		width: 460px;
		height: 176px;
		border: 1px solid #eeeeee;
		border-radius: 4px;
		margin-left: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		padding-top: 20px;
	}

	.bank-img-box-font {
		width: 178px;
		height: 120px;
		background: #f9f9f9;
		border-radius: 4px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		margin-right: 20px;
	}

	.img-common-img-box {
		width: 478px;
		height: 181px;
		border: 1px solid #eeeeee;
		border-radius: 4px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-left: 20px;
	}

	.btn-box {
		width: 100%;
		height: 200px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #ffffff;
	}

	.cancel {
		width: 90px;
		height: 30px;
		background: #ffffff;
		border: 1px solid #e5e5e5;
		border-radius: 6px;
		font-size: 14px;
		color: #333333;
		text-align: center;
		line-height: 30px;
		cursor: pointer;
	}

	.confirm {
		width: 90px;
		height: 30px;
		background: #2eb779;
		border: 1px solid #2eb779;
		border-radius: 6px;
		font-size: 14px;
		color: #fff;
		margin-left: 30px;
		text-align: center;
		line-height: 30px;
		cursor: pointer;
	}

	:deep(.input_box .el-input) {
		width: 100%;
	}

	.m-top10 {
		margin-top: 10px;
	}

	.m-top20 {
		margin-top: 20px;
	}

	.rpt_warp {
		width: 100%;
		background: #fff;
	}

	.rpt_tit {
		width: 100%;
		height: 70px;
		border-bottom: 1px solid #eeeeee;
		text-align: left;
		font-weight: bold;
		line-height: 70px;
		font-size: 18px;
		color: #333333;
		text-indent: 42px;
	}

	.rpt_box1 {
		width: 100%;
		height: 240px;
	}

	.pic-box {
		display: flex;

		margin-left: 42px;
	}

	.pic {
		width: 154px;
		height: 154px;
		border: 1px solid #eeeeee;
		border-radius: 4px;
		margin-left: 10px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.pic .upload-icon {
		width: 54px;
		height: 54px;
	}

	.pic .userHeadImg {
		width: 154px;
		height: 154px;
	}

	.identity-card {
		display: flex;
		margin-left: 50px;
	}

	.identity {
		width: 227px;
		height: 150px;
		margin-left: 10px;
		margin-right: 40px;
	}

	.identity img {
		width: 227px;
		height: 150px;
	}

	.rpt_box2 {
		width: 100%;
		padding-top: 30px;
		padding-bottom: 30px;
	}

	.input_row {
		width: 98%;
		margin-left: 1%;
		height: 38px;
		margin-bottom: 30px;
		display: flex;
		justify-content: space-between;
	}

	.input_row2 {
		width: 95%;
		margin-left: 1%;
		height: 88px;
		margin-bottom: 30px;
		display: flex;
		justify-content: space-between;
	}

	.input_cell {
		width: 33%;
		height: 38px;
		display: flex;
		align-items: center;
	}

	.input_cell2 {
		width: 33%;
		height: 150px;
		display: flex;
		align-items: center;
	}

	.input_cell .label {
		width: 148px;
		text-align: right;
	}

	.input_box {
		flex: 1;
		height: 100%;
		margin-left: 30px;
		display: flex;
		align-items: center;
	}

	.rpt_box3 {
		width: 100%;
		height: 286px;
		justify-content: space-between;
	}

	.rpic_img_warp {
		margin-left: 62px;
	}

	.rpic_img_box {
		width: 479px;
		height: 200px;
		border: 1px solid #eeeeee;
		border-radius: 4px;
		margin-left: 10px;
		display: flex;
		flex-wrap: wrap;
	}

	.rpic_img_box2 {
		width: 200px;
		height: 200px;
		border: 1px solid #eeeeee;
		border-radius: 4px;
		margin-left: 10px;
		display: flex;
		align-items: flex-start;
	}

	.upRpic_icon_item {
		margin-top: 20px;
		width: 125px;
		height: 60px;
		margin-left: 20px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		border: 1px solid #eeeeee;
		position: relative;
	}

	.upRpic_icon_item2 {
		margin-top: 0px;
		width: 125px;
		height: 125px;
		margin-left: 20px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		border: 1px solid #eeeeee;
		position: relative;
	}

	.upRpic_icon {
		width: 20px;
		height: 20px;
	}

	.image-box-item-del {
		position: absolute;
		right: 0;
		top: 0;
		width: 20px;
		height: 20px;
		cursor: pointer;
	}

	.image-box-item-del img {
		width: 20px;
		height: 20px;
	}

	.rpic_img_text {
		width: 100px;
		height: 200px;
		display: flex;
		flex-direction: column;
		align-content: center;
		justify-content: center;
	}

	.cretUrl_img_warp {
		height: 181px;
	}

	.cretUrl_img_box {
		width: 360px;
		height: 180px;
		border: 1px solid #eeeeee;
		border-radius: 4px;
		margin-left: 15px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 30px;
	}

	.rpt_box4 {
		width: 98%;
		margin-left: 1%;
		padding: 30px 0;
		border-bottom: 1px solid #eeeeee;
	}

	.rpt_bank_info {
		width: 50%;
	}

	.rpt_bank_row {
		width: 100%;
		height: 38px;
		display: flex;
		align-items: center;
		margin-bottom: 20px;
	}

	.rpt_bank_lable {
		width: 148px;
		text-align: right;
	}

	.bank_input_box {
		width: 500px;
		margin-left: 20px;
	}

	.rpt_bank_img_warp {
		width: 50%;
		display: flex;
		margin-right: 30px;
	}

	.bank_card_img_warp {
		width: 478px;
		height: 176px;
		border: 1px solid #eeeeee;
		border-radius: 4px;
		margin-left: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.conName_input {
		border: none;
		outline: none;
		flex: 1;
		padding-left: 10px;
	}

	.fuzi {
		width: 35px;
		height: 16px;
		background: #20ca68;
		border-radius: 4px;
		text-align: center;
		line-height: 16px;
		font-size: 12px;
		color: #fff;
		padding: 0 5px;
	}

	.serach_btn {
		width: 87px;
		height: 38px;
		background: #2EB779;
		border-radius: 6px;
		text-align: center;
		line-height: 38px;
		color: #fff;
		cursor: pointer;
		margin-left: 20px;
	}

	.menu_warp {
		width: 100%;
		height: 100%;
		background: #f5f5f4;
		overflow: auto;
	}

	.tit_warp {
		width: 100%;
		box-sizing: border-box;
		padding-left: 20px;
		padding-right: 20px;
		margin-bottom: 20px;
		height: 42px;
		line-height: 42px;
		font-size: 14px;
		color: #333;
		overflow: hidden;
		background-color: #fff;
		border-radius: 2px 2px 0 0;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.header_warp {
		width: 100%;
		height: 60px;
		background: #ffffff;
	}

	.editimg {
		width: 100px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		margin-right: 10px;
		cursor: pointer;
		color: blue;
	}

	.editimg img {
		width: 14px;
		height: 15px;
		margin-right: 8px;
	}
</style>